import { SsnMaskedComponent } from './components/ssn-masked/ssn-masked.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TextMaskModule } from 'angular2-text-mask';
//import {UniqueSelectionDispatcher} from ' @angular/cdk/collections'
import {
  MatButtonModule,  
 MatCheckboxModule,  
 MatInputModule,
 MatExpansionModule,
 MatDividerModule,
 MatTabsModule,
 MatIconModule,
 MatProgressSpinnerModule,
 MatSelectModule,
 MatDialogModule,
 MatStepperModule,
 MatFormFieldModule,
 MatCardModule,
 MatDatepickerModule,
 MatNativeDateModule,
 MatToolbarModule,
 MatTooltipModule,
 MatAutocompleteModule,
 MatProgressBarModule,
 MatTableModule,
 MatSnackBarModule} from '@angular/material';
 import 'hammerjs';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
 
//import { MDBBootstrapModule } from 'angular-bootstrap-md';
  
//import { AngularFontAwesomeModule } from 'angular-font-awesome/angular-font-awesome';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatDatepickerModule,
    MatTabsModule,
    MatDividerModule,
    MatExpansionModule,
    MatNativeDateModule,
    MatInputModule,
    TextMaskModule    
    //MatDialogModule
  ],
  exports:[
    FormsModule,
    TextMaskModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatButtonModule, 
    MatCheckboxModule,
    MatInputModule,
    MatTabsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatDialogModule,
    MatStepperModule,
    MatCardModule,
    MatCheckboxModule,
    MatTabsModule,
    MatExpansionModule,
    MatDividerModule,
   // UniqueSelectionDispatcher    
    MatDatepickerModule,
    MatNativeDateModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    MatSnackBarModule,
    MatTableModule,
    SsnMaskedComponent  
  ],
  declarations: [ 
    SsnMaskedComponent, FileUploadComponent 
  ]
})
export class SharedModule {
  // static forRoot():ModuleWithProviders{
  //   return{
      
  //   }
  // }
 }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts